import Grid from '@mui/material/Grid2';
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
  useMediaQuery
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Str from '../../Assets/images/celebritiespics/str.jpg';
import Arunvijay from '../../Assets/images/celebritiespics/arunvijay.jpg';
import Mahath from '../../Assets/images/celebritiespics/mahath.jpg';
import AksharaReddy from '../../Assets/images/celebritiespics/AksharaReddy.heic';
import AishwaryaDutta from '../../Assets/images/celebritiespics/AishwaryaDutta.jpg';
import Shirish from '../../Assets/images/celebritiespics/SHIRISH.jpg';
import Atharva from '../../Assets/images/celebritiespics/Atharva.jpg';
import Niroop from '../../Assets/images/celebritiespics/niroop.heic';
import priyandhespande from '../../Assets/images/celebritiespics/priyandhespande.jpg';

const CelebrityTraining = () => {
  const celebrities = [
    {
      name: 'STR',
      image: Str
    },
    {
      name: 'Arun Vijay',
      image: Arunvijay
    },
    {
      name: 'Shirish',
      image: Shirish
    },
    {
      name: 'Atharva',
      image: Atharva
    },
    {
      name: 'Mahath',
      image: Mahath
    },
    {
      name: 'Akshara Reddy',
      image: AksharaReddy
    },
    {
      name: 'Aishwarya Dhutta',
      image: AishwaryaDutta
    },
    {
      name: 'Niroop Nandakumar',
      image: Niroop
    },
    {
      name: 'Priyanka Deshpande',
      image: priyandhespande
    }
  ];

  const [celebirityData, setCelebirityData] = useState(celebrities);

  const navigate = useNavigate();
  const location = useLocation();

  const { pathname = '' } = location;

  const isCelebrityPage = pathname.includes('cele');

  const isMobile = useMediaQuery('(max-width:768px)');

  useEffect(() => {
    const pageData = !isCelebrityPage ? celebrities.slice(0, 4) : celebrities;
    setCelebirityData(pageData);
  }, [pathname]);

  return (
    <Box
      id="celebrity-training-section"
      sx={{
        padding: '20px',
        background: '#333333',
        color: 'white',
        paddingTop: isCelebrityPage ? '80px' : null
      }}
    >
      {/* Title Section */}
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#26BDBE',
          fontFamily: 'Raleway'
        }}
      >
        Celebrity Training
      </Typography>
      <Typography
        variant="body1"
        gutterBottom
        sx={{
          textAlign: 'center',
          marginBottom: '30px',
          color: '#999999',
          fontStyle: 'italic',
          fontFamily: 'Raleway'
        }}
      >
        Train like a celebrity with our personalized fitness programs designed
        to help you achieve your goals.
      </Typography>

      {/* Subtitle */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          marginBottom: '20px',
          fontFamily: 'Raleway',
          color: '#c7c7c7',
          textAlign: isMobile ? 'center' : 'start'
        }}
      >
        Our Celebrity Clients
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginBottom: '20px',
          fontFamily: 'Raleway',
          fontStyle: 'oblique',
          fontWeight: '500',
          color: '#979797',
          textAlign: isMobile ? 'center' : 'start'
        }}
      >
        {`We've had the privilege of working with some of the biggest names in the
        entertainment industry, including:`}
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {celebirityData.map((celeb, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Card sx={{ maxWidth: 300, margin: '0 auto' }}>
              <CardMedia
                component="img"
                image={celeb.image}
                alt={celeb.name}
                sx={{
                  height: 200, // Fixed height
                  width: 250, // Ensures the image spans the width of the card
                  objectFit: 'cover', // Adjust to 'contain' if you don't want any part cropped
                  objectPosition: 'top' // Ensures focus on the top of the imageakfs
                }}
              />
              <CardContent>
                <Typography
                  style={{
                    color: '#363636',
                    fontWeight: '900',
                    fontFamily: 'Raleway',
                    fontStyle: 'oblique'
                  }}
                  variant="h6"
                >
                  {celeb.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Grid
        container
        style={{
          marginTop: '20px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onClick={() => {
          navigate('/celebrities');
        }}
      >
        {!isCelebrityPage && (
          <Button
            style={{ background: 'white', color: '#2d2b2b' }}
            variant="contained"
          >
            View More
          </Button>
        )}
      </Grid>
    </Box>
  );
};

export default CelebrityTraining;
